<template>
    <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
        <el-form-item label="能力" prop="type">
            <el-input placeholder="请输入能力" v-model="rule.type" clearable></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
            <el-input placeholder="请输入名称" v-model="rule.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="unit">
            <el-input  placeholder="请输入单位" v-model="rule.unit" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="des">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入描述" v-model="rule.des" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="block">返回</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        data() {
            return {
                name: 'edit',
                rule: {
                    id: 0,
                    type: '',
                    name: '',
                    unit: '',
                    des: '',
                },
                rules: {
                    type: { required: true, message: '请输入能力' },
                    name: {required: true, message: '请输入名称'},
                    unit: {required: true, message: '请输入单位'},
                    des: {required: true, message: '请输入描述'},
                },
            }
        },
        async created() {
            if(this.$route.params.id) {
                if(!!this.$store.state.editInfo) {
                    this.rule = this.$store.state.editInfo
                }else {
                    this.$router.push('/equipment/portable/power');
                }
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        if(this.rule.id == 0) {
                            this.$http.post('/manage/ability/add',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/equipment/portable/power');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }else {
                            this.$http.post('/manage/ability/edit',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/equipment/portable/power');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                        
                    }
                });
            },
            block() {
                this.$router.go(-1);
            },
        }
    }
</script>